module.exports = __webpack_public_path__ + "media/src/assets/lyrnlinkwhite-1dca4f327c51745e66e97850958fde18.svg";